<main>
  <section class="container" id="apresentacao">
    <h1 class="title" *ngIf="catalogo">Apresentação</h1>
    <hr class="bg-color-dark-grey hr-line" />
    <div class="text" [innerHTML]="apresentacao | textToLink | format"></div>
  </section>
  <section class="time-line bg-color-primary">
    <h1 class="title text-center color-white">Histórico das Edições do Catálogo</h1>
    <p class="text-center color-white" style="margin: 1.2rem 0">
      Evolução do Catálogo Nacional de Cursos Técnicos (CNCT)
    </p>
    <div class="container time-line-container">
      <button class="time-line-btn left cursor-pointer" (click)="irParaAnterior()" role="button"
        aria-label="irParaAnterior">
        anterior
      </button>
      <hr class="bg-color-white hr-line" />
      <p class="catalogue-edition color-white">{{ catalogoSelecionado.id }}ª Edição</p>
      <h2 class="catalogue-desc color-white">
        {{ catalogoSelecionado.evolucao }}
      </h2>
      <p role="text" class="catalogue-date color-white">
        {{ catalogoSelecionado.data }}
      </p>
      <a *ngIf="catalogoSelecionado.id !== 4" [href]="baseUrlCatalogo + catalogoSelecionado.nome" target="_blank"
        rel="noreferrer" class="link color-dark rounded-pill btn btn-white small">Mais Informações</a>
      <a *ngIf="catalogoSelecionado.id === 4" routerLink="{{ catalogoSelecionado.url }}"
        class="link color-dark rounded-pill btn btn-white small">Navegue pelos cursos</a>
      <button class="time-line-btn right cursor-pointer" (click)="irParaProximo()" type="button" role="button"
        aria-label="irParaProximo">
        próximo
      </button>
    </div>

    <span role="group" class="time-line-nav container">
      <span class="nav-item" *ngFor="let catalogo of catalogos">
        <span role="text" class="color-white">{{ catalogo.id }}ª Edição</span>
        <input *ngIf="catalogo" type="radio" id="edicao-{{ catalogo.id }}" class="nav-dot color-white"
          (click)="selecionaEdicao(catalogo.id)" [ngClass]="{
            active: catalogo.id === catalogoSelecionado.id
          }" [checked]="catalogo.id === catalogoSelecionado.id" />

        <label for="edicao-{{ catalogo.id }}" role="text" class="nav-year text--white">{{
          catalogo.ano
          }}</label>
      </span>
      <span role="text" class="color-white text-float text-uppercase">próximo</span>
    </span>
  </section>
</main>